export default __webpack_public_path__ + "static/dorothy-62728d76242232e79a596c1bf51ddebd.png";